/**
 * SafariShareDiagram — inline SVG mock of the Safari URL bar with the Share
 * button circled. Removes the "where is the share button?" confusion that
 * users hit when shown only text instructions.
 */
interface Props {
  /** "bottom" for iPhone portrait, "top" for iPad / iPhone landscape. */
  position?: "bottom" | "top";
}

export function SafariShareDiagram({ position = "bottom" }: Props) {
  const label = position === "bottom" ? "Bottom of Safari" : "Top-right of Safari";
  return (
    <div className="mt-2 rounded-lg border border-border bg-muted/40 p-2">
      <div className="text-[9px] uppercase tracking-wider font-bold text-muted-foreground text-center mb-1">
        {label}
      </div>
      <svg
        viewBox="0 0 280 44"
        className="w-full h-auto"
        role="img"
        aria-label="Safari URL bar with the share button circled"
      >
        {/* URL bar background */}
        <rect x="6" y="8" width="268" height="28" rx="8" fill="hsl(var(--background))" stroke="hsl(var(--border))" />
        {/* aA icon */}
        <text x="18" y="27" fontSize="11" fontWeight="600" fill="hsl(var(--muted-foreground))">aA</text>
        {/* URL text */}
        <text x="44" y="27" fontSize="10" fill="hsl(var(--foreground))">goaldigger.dev</text>
        {/* Share icon group */}
        <g transform="translate(228, 14)">
          {/* Box */}
          <rect x="1" y="6" width="14" height="12" rx="2" fill="none" stroke="hsl(217 91% 60%)" strokeWidth="1.5"/>
          {/* Up arrow */}
          <line x1="8" y1="2" x2="8" y2="13" stroke="hsl(217 91% 60%)" strokeWidth="1.5" strokeLinecap="round"/>
          <polyline points="4,5 8,1 12,5" fill="none" stroke="hsl(217 91% 60%)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        {/* Circle around share icon */}
        <circle cx="236" cy="24" r="14" fill="none" stroke="hsl(24 95% 53%)" strokeWidth="2" strokeDasharray="3 2">
          <animate attributeName="r" values="14;16;14" dur="1.6s" repeatCount="indefinite" />
        </circle>
        {/* Arrow pointer */}
        <g stroke="hsl(24 95% 53%)" strokeWidth="1.5" fill="none">
          <line x1="200" y1="38" x2="228" y2="30" strokeLinecap="round"/>
          <polyline points="222,28 228,30 226,35" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <text x="180" y="42" fontSize="9" fontWeight="700" fill="hsl(24 95% 53%)">Tap this</text>
      </svg>
    </div>
  );
}
